import Title from 'antd/es/typography/Title';
//const dotenv = require('dotenv');
import {useEffect, useState} from 'react';
import {getCurrentAuthEmail} from '../../utils';

export const Dashboard = () => {
  const [currentUserEmail, setCurrentUserEmail] = useState<string>();
  useEffect(() => {
    setCurrentUserEmail(getCurrentAuthEmail());
  }, []);

  return (
    <Title>
      Dashboard in progress : {`\n`} {currentUserEmail}
    </Title>
  );
};
